import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../../fonts.css';
import Title from './Title';
import SelectorFrame from './SelectorComponent';
import ScanSearch from './ScanSearchComponent';
import MidComponent from './MidComponent';
import { isLanguageRTL } from '../reusableComponents/LanguageList'; // Import the RTL helper

const StyledDiv = styled.div`
  font-family: 'JohnsonText-Regular', sans-serif;
  margin-bottom: 10px;
  text-align: ${props => props.isRTL ? 'right' : 'left'};
`;

const StyledSelectorFrame = styled(Box)`
  display: flex;
  justify-content: ${props => props.isRTL ? 'flex-start' : 'flex-end'};
  padding: 0 8px;
`;

function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { t, i18n } = useTranslation();
  const isRTL = isLanguageRTL(i18n.language); // Get RTL status

  const padding = '16px 8px 8px 8px';
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div dir={isRTL ? 'rtl' : 'ltr'}> {/* Wrap entire component with dir attribute */}
      {isMobile ? (
        <>
          <Title 
            title={t('main.title')} 
            isMobile={isMobile} 
            titlePaddingStyle={padding}
            isRTL={isRTL}
          />
          <Box
            sx={{
              maxWidth: `${windowWidth}`,
              padding: '0px 8px',
            }}
          >
            <StyledDiv isRTL={isRTL}>{t('main.patientInfo')}</StyledDiv>
            <StyledSelectorFrame isRTL={isRTL}>
              <SelectorFrame isMobile={isMobile} isRTL={isRTL} />
            </StyledSelectorFrame>
          </Box>
          <Box
            sx={{
              maxWidth: `${windowWidth}`,
              padding: '0 8px',
              borderBottom: '2px dotted #D2DCE6',
            }}
          >
            <ScanSearch isMobile={isMobile} isRTL={isRTL} />
          </Box>
          <Box
            sx={{
              maxWidth: `${windowWidth}`,
              padding: '16px 0',
              borderBottom: '2px dotted #D2DCE6',
              gap: '8px',
            }}
          >
            <MidComponent isMobile={isMobile} isRTL={isRTL} />
          </Box>
        </>
      ) : (
        <div className="main-container">
          <Title title={t('main.title')} isRTL={isRTL} />
          <StyledDiv isRTL={isRTL}>{t('main.patientInfo')}</StyledDiv>
          <StyledSelectorFrame isRTL={isRTL}>
            <SelectorFrame isRTL={isRTL} />
          </StyledSelectorFrame>
          <ScanSearch isRTL={isRTL} />
          <MidComponent isRTL={isRTL} />
        </div>
      )}
    </div>
  );
}

export default Home;